// 热更新HTML页面
if (process.env.NODE_ENV !== 'production') {
  require('html-loader!./index.html')
}